import Api from "../../../app/apiRequest";
import BaseResponse from "../../../app/BaseResponse";
import CompanyNamePICModel from "../models/CompanyNamePICModel";
import CompanyNamePICQueryModel from "../models/CompanyNamePICQueryModel";

export interface SearchCompanyNamePICParam {
    pageSize: number,
    query: CompanyNamePICQueryModel
}

export interface GetCompanyNamePICByIdParam {
    id: string,
}

export interface GetCompanyNamePICByIdsParam {
    ids: string[],
}

export interface DeleteCompanyNamePICByIdParam {
    id: string,
}
export interface SearchCompanyNamePICNameParam {
    keyword: string,
}

const CompanyNamePICApi = {
    SearchName(param: SearchCompanyNamePICNameParam) {
        return Api.get<SearchCompanyNamePICNameParam, BaseResponse<CompanyNamePICModel[]>>("/api/CompanyNamePIC/SearchName", param);
    },
    Search(param: SearchCompanyNamePICParam) {
        return Api.post<SearchCompanyNamePICParam, BaseResponse<CompanyNamePICModel[]>>("/api/CompanyNamePIC/Search", param);
    },
    GetAll() {
        return Api.get<unknown, BaseResponse<CompanyNamePICModel[]>>("/api/CompanyNamePIC/GetAll", null);
    },
    Save(param: CompanyNamePICModel) {
        return Api.post<CompanyNamePICModel, BaseResponse<CompanyNamePICModel>>("/api/CompanyNamePIC/Save", param);
    },
    GetById(param: GetCompanyNamePICByIdParam) {
        return Api.get<GetCompanyNamePICByIdParam, BaseResponse<CompanyNamePICModel>>("/api/CompanyNamePIC/GetById", param);
    },
    GetByIds(param: GetCompanyNamePICByIdsParam) {
        return Api.post<GetCompanyNamePICByIdsParam, BaseResponse<CompanyNamePICModel[]>>("/api/CompanyNamePIC/GetByIds", param);
    },
    Delete(param: DeleteCompanyNamePICByIdParam) {
        return Api.post<DeleteCompanyNamePICByIdParam, BaseResponse<CompanyNamePICModel>>("/api/CompanyNamePIC/Delete", param);
    },
};
export default CompanyNamePICApi;